module.exports = __webpack_public_path__ + "static/media/minus-sign.4bb7927b.svg";